module.exports = __webpack_public_path__ + "media/images/icon-header-comm-078db0bcff8d279d97288d70f0f1f3b1.svg";